import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApiDataState, apiDataFeatureKey } from './api-data.reducer';

export const selectApiDataState = createFeatureSelector<ApiDataState>(apiDataFeatureKey);

export const selectApiDataSections = createSelector(
  selectApiDataState,
  (state: ApiDataState) => state.sections
);
